"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Warning = _interopRequireDefault(require("@mui/icons-material/Warning"));
var _Info = _interopRequireDefault(require("@mui/icons-material/Info"));
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _FormHelperText = _interopRequireDefault(require("@mui/material/FormHelperText"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _HiFormLabel = _interopRequireDefault(require("./HiFormLabel"));
var _HiIconButton = _interopRequireDefault(require("../HiIconButton"));
var _helpers = require("../utils/helpers");
var _index = _interopRequireDefault(require("keycode/index"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // @inheritedComponent FormControl
var styles = exports.styles = function styles(theme) {
  return {
    helperTextClassName: {
      color: theme.palette.neutral.main,
      fontSize: 11,
      textAlign: 'right',
      marginTop: 2
    },
    iconButton: {
      cursor: 'pointer',
      zIndex: 1,
      height: 20,
      width: 20,
      marginLeft: 3,
      '&$iconButtonError': {
        color: theme.palette.error.main
      },
      '&$iconButtonInfo': {
        color: theme.palette.neutral.main
      },
      '&$iconButtonInfoActive': {
        color: theme.palette.primary.main
      },
      '&$iconFullWidth': {
        position: 'absolute',
        right: theme.spacing(1),
        marginLeft: 0,
        bottom: 0
      }
    },
    iconButtonError: {},
    iconButtonInfo: {},
    iconButtonInfoActive: {},
    iconFullWidth: {},
    errorDiv: (0, _objectSpread2.default)({}, theme.typography.body3, {
      backgroundColor: theme.palette.error.main,
      color: '#FFFFFF',
      padding: theme.spacing(4, 2),
      verticalAlign: 'middle',
      borderRadius: 2,
      position: 'relative',
      marginBottom: theme.spacing(2)
    }),
    arrowDown: {
      width: 0,
      height: 0,
      borderLeft: '4px solid transparent',
      borderRight: '4px solid transparent',
      borderTop: '4px solid #000',
      position: 'absolute',
      bottom: theme.spacing(-1),
      '&$arrowNotFullWidth': {
        left: theme.spacing(2)
      },
      '&$arrowFullWidth': {
        right: theme.spacing(3)
      }
    },
    arrowNotFullWidth: {},
    arrowFullWidth: {},
    errorDivArrowDown: {
      borderTopColor: theme.palette.error.main
    },
    helperDiv: (0, _objectSpread2.default)({}, theme.typography.body2, {
      width: '100%',
      backgroundColor: '#ffffff',
      color: theme.palette.neutral.normal,
      padding: theme.spacing(4, 2),
      borderRadius: 2,
      position: 'relative',
      marginBottom: theme.spacing(2),
      boxShadow: '0px 1px 7px rgba(0, 0, 0, 0.16)'
    }),
    helperDivArrowDown: {
      borderTopColor: '#ffffff'
    },
    icon: {
      position: 'absolute',
      fontSize: 20,
      top: 5
    }
  };
};

/**
 * Champs input pour formulaire
 */
var HiFormControl = /*#__PURE__*/function (_React$PureComponent) {
  function HiFormControl(props) {
    var _this;
    (0, _classCallCheck2.default)(this, HiFormControl);
    _this = _callSuper(this, HiFormControl, [props]);
    _this.handleHelperClick = function (event) {
      _this.setState(function (prevState) {
        return {
          helperOpen: !prevState.helperOpen
        };
      });
      if (event) {
        event.preventDefault();
      }
    };
    _this.handleKeyDown = function (event) {
      var key = (0, _index.default)(event);
      if (['space', 'enter'].includes(key)) {
        _this.handleHelperClick(event);
      }
    };
    _this.handleHover = function (value) {
      return function () {
        _this.setState({
          hovered: value
        });
      };
    };
    _this.handleFocus = function (value) {
      return function () {
        _this.setState({
          focused: value
        });
        if (value === false && _this.state.hovered) {
          _this.setState({
            hovered: false
          });
        }
      };
    };
    _this.state = {
      helperOpen: false,
      focused: false,
      hovered: false
    };
    _this.handleHelperClick = _this.handleHelperClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleHover = _this.handleHover.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(HiFormControl, _React$PureComponent);
  return (0, _createClass2.default)(HiFormControl, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        classes = _this$props.classes,
        className = _this$props.className,
        disabled = _this$props.disabled,
        error = _this$props.error,
        errorText = _this$props.errorText,
        id = _this$props.id,
        label = _this$props.label,
        InputLabelProps = _this$props.InputLabelProps,
        helperText = _this$props.helperText,
        helperIcon = _this$props.helperIcon,
        FormHelperTextProps = _this$props.FormHelperTextProps,
        fullWidth = _this$props.fullWidth,
        required = _this$props.required,
        multiline = _this$props.multiline,
        rootRef = _this$props.rootRef,
        maxLength = _this$props.maxLength,
        nbChars = _this$props.nbChars,
        others = (0, _objectWithoutProperties2.default)(_this$props, ["children", "classes", "className", "disabled", "error", "errorText", "id", "label", "InputLabelProps", "helperText", "helperIcon", "FormHelperTextProps", "fullWidth", "required", "multiline", "rootRef", "maxLength", "nbChars"]);
      var _this$state = this.state,
        helperOpen = _this$state.helperOpen,
        focused = _this$state.focused,
        hovered = _this$state.hovered;
      return /*#__PURE__*/_react.default.createElement(_FormControl.default, (0, _extends2.default)({
        fullWidth: fullWidth,
        className: className,
        error: error,
        ref: rootRef,
        variant: "standard"
      }, others), error && errorText && helperOpen && /*#__PURE__*/_react.default.createElement("div", {
        className: classes.errorDiv
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(classes.arrowDown, classes.errorDivArrowDown, fullWidth ? [classes.arrowFullWidth] : [classes.arrowNotFullWidth])
      }), /*#__PURE__*/_react.default.createElement("span", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
          __html: (0, _helpers.escapeHTML)(errorText)
        }
      })), helperIcon && helperText && !error && helperOpen && /*#__PURE__*/_react.default.createElement("div", {
        className: classes.helperDiv
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(classes.arrowDown, classes.helperDivArrowDown, fullWidth ? [classes.arrowFullWidth] : [classes.arrowNotFullWidth])
      }), /*#__PURE__*/_react.default.createElement("span", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
          __html: (0, _helpers.escapeHTML)(helperText)
        }
      })), label && /*#__PURE__*/_react.default.createElement(_HiFormLabel.default, (0, _extends2.default)({
        htmlFor: id,
        label: label,
        required: required,
        disabled: disabled,
        focused: !disabled && (focused || hovered)
      }, InputLabelProps), error && errorText && /*#__PURE__*/_react.default.createElement(_HiIconButton.default, {
        className: (0, _classnames.default)(classes.iconButton, classes.iconButtonError, (0, _defineProperty2.default)({}, classes.iconFullWidth, fullWidth)),
        onClick: this.handleHelperClick
      }, /*#__PURE__*/_react.default.createElement(_Warning.default, {
        fontSize: "small",
        className: (0, _classnames.default)(classes.icon)
      })), helperIcon && helperText && !error && /*#__PURE__*/_react.default.createElement(_HiIconButton.default, {
        className: (0, _classnames.default)(classes.iconButton, classes.iconButtonInfo, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.iconButtonInfoActive, helperOpen), classes.iconFullWidth, fullWidth)),
        onClick: this.handleHelperClick
      }, /*#__PURE__*/_react.default.createElement(_Info.default, {
        fontSize: "small",
        className: (0, _classnames.default)(classes.icon)
      }))), /*#__PURE__*/_react.default.createElement("div", {
        onMouseEnter: this.handleHover(true),
        onMouseLeave: this.handleHover(false),
        onFocus: this.handleFocus(true),
        onBlur: this.handleFocus(false)
      }, children), !multiline && helperText && !helperIcon && /*#__PURE__*/_react.default.createElement(_FormHelperText.default, (0, _extends2.default)({
        className: classes.helperTextClassName
      }, FormHelperTextProps), helperText), multiline && /*#__PURE__*/_react.default.createElement(_FormHelperText.default, (0, _extends2.default)({
        className: classes.helperTextClassName
      }, FormHelperTextProps), nbChars, "/", maxLength));
    }
  }]);
}(_react.default.PureComponent);
HiFormControl.defaultProps = {
  id: (0, _helpers.uniqueId)(),
  fullWidth: true,
  required: true,
  disabled: false,
  error: false,
  errorText: undefined,
  helperText: undefined,
  helperIcon: false,
  multiline: false,
  nbChars: 0,
  maxLength: 280
};
var _default = exports.default = (0, _withStyles.default)(styles, {
  hiComponent: true,
  name: 'HmuiHiFormControl'
})(HiFormControl);